<div class="form-labels">
  <app-label *ngFor="let label of labels" (removeFromCollection)="removeLabel($event)" [label]="label" [isEditable]="isEditable"></app-label>
  <ng-template #labelTypeaheadResult let-label="result" let-term="term">
    <span *ngIf="label === null && error">Unable to load labels</span>
    <span *ngIf="label === null && loading && !error">Loading labels...</span>
    <span *ngIf="label === null && !loading && !error">No Labels Found</span>
    <span *ngIf="label !== null">
      <span [style.backgroundColor]="label.backgroundColor" style="width:1.2rem;height:1.2rem;display:inline-block;margin:0 0.5rem 0 -0.5rem">&nbsp;</span>
      <ngb-highlight [result]="label.name" [term]="term"></ngb-highlight>
    </span>
  </ng-template>
  <input type="text" class="form-control" [placeholder]="inputPlaceholder" [ngbTypeahead]="search" [editable]="false"
  [resultTemplate]="labelTypeaheadResult" [inputFormatter]="labelInputFormatter" (focus)="focus$.next($event.target.value)"
  (click)="click$.next($event.target.value.name)" (selectItem)="addLabel($event)" #instance="ngbTypeahead">
</div>
